import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../Redux/authSlice";
import { useAuth } from "../context/AuthContext";
import Loader from "../component/Loader/Loader";

const PublicRoute = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { loading } = useAuth();

  if (loading) {
    return <Loader />;
  }

  if (isLoggedIn) {
    const history = JSON.parse(localStorage.getItem("pathHistory")) || [];
    const secondLastPath =
      history.length > 1 ? history[history.length - 2] : "/";
    return <Navigate to={secondLastPath} replace />;
  }

  return children;
};

export default PublicRoute;
